import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const LogoIntro = ({ onComplete, userName }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 3400);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#111827',
          zIndex: 9999
        }}
      >
        <motion.img
          src="/logo.png"
          alt="Logo"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ 
            scale: [0.5, 1.1, 1],
            opacity: [0, 1, 1]
          }}
          exit={{ scale: 0.5, opacity: 0 }}
          transition={{ 
            duration: 2,
            times: [0, 0.6, 1],
            ease: "easeOut"
          }}
          style={{
            width: '400px',
            height: 'auto',
            marginBottom: '2rem'
          }}
        />
        {userName && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ delay: 1, duration: 0.5 }}
            style={{
              color: 'white',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Dobrodošli, {userName}!
          </motion.div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default LogoIntro;
